import ErrorToast from "../../../components/common/toasts/ErrorToast";
import React from "react";
import { Link } from "react-router-dom";

/** Pokazuje formularz dopiero po odczycie danych i obsługuje powrót oraz błędy. */
export default function PremiumFormPanel({
  title,
  description,
  resource,
  error,
  loadingLabel = "Ładowanie danych…",
  backTo,
  children,
}) {
  const message = error || resource.error;
  return (
    <section className="card premium-panel">
      <h2>{title}</h2>
      {description && <p className="small text-muted">{description}</p>}
      <ErrorToast message={message} />
      {resource.loading && <p role="status">{loadingLabel}</p>}
      {resource.error && (
        <button className="btn btn-outline-primary" onClick={resource.reload}>
          Ponów odczyt
        </button>
      )}
      {resource.data && !message ? (
        children
      ) : (
        <Link to={backTo}>Wróć do listy</Link>
      )}
    </section>
  );
}
